import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { ICON_SETTINGS, IconSettingsService, IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MyIconService } from './my-icon.service';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { NgModule } from '@angular/core';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PopoverModule, TooltipModule } from '@progress/kendo-angular-tooltip';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { UploadModule } from '@progress/kendo-angular-upload';

@NgModule({
    exports: [
        ButtonsModule,
        DialogsModule,
        DropDownsModule,
        ExcelModule,
        GridModule,
        IconsModule,
        IndicatorsModule,
        InputsModule,
        LabelModule,
        LayoutModule,
        NavigationModule,
        NotificationModule,
        PopoverModule,
        PopupModule,
        ProgressBarModule,
        TooltipModule,
        UploadModule
    ],
    providers: [
        { provide: ICON_SETTINGS, useValue: { type: 'font' } },
        { provide: IconSettingsService, useClass: MyIconService },
    ],
})

export class KendoModule { }